<template>
  <div>
    <!-- 轮播图-->
    <carousel-page :type='4'></carousel-page>
    <!-- 轮播图结束 -->
    <!-- 研学教育 -->

    <section id='yanxuejiaoxu' class="feature-area section-padding2">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="section-top text-center">
              <h2 class='title borderBCD'>研学教育</h2>
              <p class='titleShadow'>RESEARCH EDUCATION</p>
            </div>
          </div>
        </div>

      </div>

      <div class="container">

        <div class="row">
          <div style='margin-bottom: 20px;' :class="index<2?'col-lg-6':'col-lg-4'" v-for='(item,index) in yxList'
            :index='index'>
            <div class='yxItem'>
              <div class="mb-3">
                <img style='width: 100%;' :src="item.titleImage" :alt="item.subTitle">
              </div>
              <p class='yxItemTextT'>{{item.title}}</p>
              <p class='yxItemTextST'>{{item.subTitle}}</p>
              <p class='yxItemText'>{{item.content}}</p>
            </div>

          </div>

        </div>
      </div>
    </section>
    <!-- 研学教育结束 -->
    <!-- 跨境旅游 -->
    <section id='kuajinglvyou' class="feature-area section-padding2">

      <div class="">

        <div class="row">

          <div class="col-lg-12">
            <img style='width: 100%;' src="static/assets/images/feature/06.png" alt="企业介绍">

          </div>
        </div>
      </div>
    </section>
    <!-- 跨境旅游结束 -->
    <!-- 甲骨文书屋 -->
    <section id='jiaguwen' class="feature-area section-padding2">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="section-top text-center">
              <h2 class='title borderBCD'>甲骨文书屋</h2>
              <p class='titleShadow'>JIAGUWEN LIBRARY</p>
            </div>
          </div>
        </div>
        <div class="row" style='justify-content: space-between;'>
          <!-- <div class="col-lg-4 pRelative">
            <img style='width: 100%;' src="static/assets/images/feature/07.png" alt="联系我们">
            <div class='featureShuwInfo'>
              <h3>南万金甲骨文书屋</h3>
              <p>南万金甲骨文书屋环境优雅，停车方便，书屋内内配置自助借还书设备、自助办卡设备、led大屏搜索设备以及自助饮品机，能够高效率的满足读者朋友的各项需求。</p>
            </div>
          </div>
          <div class="col-lg-4 pRelative">
            <img style='width: 100%;' src="static/assets/images/feature/08.png" alt="联系我们">
            <div class='featureShuwInfo'>
              <h3>名苑书屋</h3>
              <p>名苑书屋别具一格、书香四溢，走进书屋首先映入眼帘的几个大字“书香名苑”，各类书籍分门别类、摆放整齐，书架上摆有绿色植物，带来勃勃生机。</p>
            </div>
          </div>
          <div class="col-lg-4 pRelative">
            <img style='width: 100%;' src="static/assets/images/feature/09.png" alt="联系我们">
            <div class='featureShuwInfo'>
              <h3>广益书屋</h3>
              <p>广益书屋位于安阳殷墟考古文旅小镇内，展现了更具安阳特色的殷商文化，书屋内有大量殷商文化书籍、殷墟考古纪实书籍，各类书籍也都紧密围绕殷商考古这个大主题。</p>
            </div>
          </div>
          <div class="col-lg-4 pRelative mt20">
            <img style='width: 100%;' src="static/assets/images/feature/10.png" alt="联系我们">
            <div class='featureShuwInfo'>
              <h3>洪河公园</h3>
              <p>洪河公园书屋优雅地座落在洪河公园东南角，绿树成荫，鸟语花香，品类繁多的书籍更是吸引不同年龄段的读者前来阅读。</p>
            </div>
          </div>
          <div class="col-lg-4 pRelative mt20">
            <img style='width: 100%;' src="static/assets/images/feature/11.png" alt="联系我们">
            <div class='featureShuwInfo'>
              <h3>实验书屋</h3>
              <p>实验书屋周围毗邻多所重点小学、地理位置优越，客流量大，交通便利；书屋环境优美，藏书丰富，遍及文学、历史、人文地理，儿童读物等，有10000多本书籍供读者选择。</p>
            </div>
          </div>
          <div class="col-lg-4 pRelative mt20">
            <img style='width: 100%;' src="static/assets/images/feature/12.png" alt="联系我们">
            <div class='featureShuwInfo'>
              <h3>元泰清华园甲骨文书屋</h3>
              <p>元泰清华园甲骨文书屋坐落于元泰清华园B区小区内，书屋建筑面积80多平方米，藏书量2700多册。书屋窗明几净，内设有空调、饮水机、手机免费“加油站”等便民服务。</p>
            </div>
          </div> -->
          <div class="col-lg-4 pRelative" style='margin-bottom: 20px;cursor: pointer;' v-for='(item,index) in jgwList' :key='index'>
            <img style='width: 100%;' :src="item.titleImage" :alt="item.title">
            <div class='featureShuwInfo'>
              <h3>{{item.title}}</h3>
              <p v-html='item.content'></p>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- 甲骨文书屋结束 -->
    <!-- 锚点-->
    <div class='SbgWarp'>
      <div class='bgtextTitle'>特色业务</div>
      <div class='fbgTextWarp'>
        <div @click='cutIndex(0)' :class='cutFbgTextIndex==0?"cutFbgTextItem":"fbgTextItem"'>研学教育</div>
        <div @click='cutIndex(1)' :class='cutFbgTextIndex==1?"cutFbgTextItem":"fbgTextItem"'>跨境旅游</div>
        <div @click='cutIndex(2)' :class='cutFbgTextIndex==2?"cutFbgTextItem":"fbgTextItem"'>甲骨文书屋</div>
      </div>
    </div>
  </div>
</template>

<script>
  import carouselPage from './module/carousel.vue'
  export default {
    components: {
      carouselPage
    },
    data() {
      return {
        cutFbgTextIndex: 0,
        jgwList: null,
        yxList: null
      }
    },
    mounted() {
      this.$http({
        method: 'get',
        url: 'http://123.57.1.182/website/api/website/article/list?type=研学教育',
        data: {}
      }).then((res) => {
        console.log(res)
        if (res.data.code == 200) {
          this.yxList = res.data.data
        }
      })
      this.$http({
        method: 'get',
        url: 'http://123.57.1.182/website/api/website/article/list?type=甲骨文书屋',
        data: {}
      }).then((res) => {
        console.log(res)
        if (res.data.code == 200) {
          this.jgwList = res.data.data
        }
      })

    },
    methods: {
      cutIndex(index) {
        this.cutFbgTextIndex = index
        if (index == 0) {
          const yanxuejiaoxu = document.getElementById("yanxuejiaoxu");
          yanxuejiaoxu.scrollIntoView({
            behavior: "smooth"
          });
        } else if (index == 1) {
          const kuajinglvyou = document.getElementById("kuajinglvyou");
          kuajinglvyou.scrollIntoView({
            behavior: "smooth"
          });
        } else if (index == 2) {
          const jiaguwen = document.getElementById("jiaguwen");
          jiaguwen.scrollIntoView({
            behavior: "smooth"
          });
        }
      }
    },
  }
</script>


// WEBPACK FOOTER //
// Feature.vue?d9aaa29c